import type { FC, PropsWithChildren } from 'react';
import { Box } from 'braid-design-system';

export interface FilterButtonProps {
  onClick?(): void;
}

export const FilterButton: FC<PropsWithChildren<FilterButtonProps>> = ({
  children,
  onClick,
}) => (
  <Box
    cursor="pointer"
    display="flex"
    justifyContent="center"
    padding="small"
    width="full"
    height="full"
    onClick={onClick}
  >
    {children}
  </Box>
);
